/* eslint-disable @typescript-eslint/no-unsafe-assignment */
declare const STAGE: string;
declare const ROLLBAR_ACCESS_TOKEN: string;

const rollbarConfig = {
	accessToken: ROLLBAR_ACCESS_TOKEN,
	captureUncaught: false,
	captureUnhandledRejections: false,
	checkIgnore: window["rollbarIgnoreWithExtraErrorsIgnored"],
	payload: {
		environment: STAGE,
	},
};

export default {
	install: (app: any): void => {
		const rollbar = window && window['rollbar'] && window['rollbarIgnore'] && window['rollbarIgnoreWithExtraErrorsIgnored']? new window['rollbar'](rollbarConfig) : null;
		window['rollbar_PQ'] = rollbar;
		app.config.errorHandler = (error): void => {
			console.error(error);
			if (STAGE === 'prd' && rollbar !== null) {
				rollbar.error(error);
			}
			//throw error;
		};
	},
};
